import createAdapter from './createAdapter'
export const strossle = createAdapter(() => !!window.strossleIsLoaded, {
  track(event) {
    window.strossleAnalytics('event', event)
  },
})
